import DOMPurify from "dompurify";

import i18n from "@/lib/i18n";

export const sanitizer = (html: string): string => {
  const origin = window.location.origin;

  DOMPurify.removeAllHooks();

  DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    if (data.tagName === "a") {
      const href = node.getAttribute("href");

      if (href?.match(/^[./]/)) {
        node.setAttribute("href", `${origin}${href}`);
      }

      // Open all external links in a new tab
      if (href?.startsWith(origin)) {
        node.setAttribute("target", "_blank");
      }
    }

    if (data.tagName === "form") {
      const action = node.getAttribute("action");
      if (action === "/legacy/opmet_file") {
        node.setAttribute("action", `${import.meta.env.VITE_API_BASE_PATH}${action}`);
      }
    }
  });

  DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    if (data.attrName === "target") {
      node.setAttribute("title", i18n.t("common.openInNewTab"));
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener");
      data.forceKeepAttr = true;
    }
  });

  return DOMPurify.sanitize(html);
};
